import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=3dab456a&scoped=true&"
import script from "./orderCenter.vue?vue&type=script&lang=js&"
export * from "./orderCenter.vue?vue&type=script&lang=js&"
import style0 from "./orderCenter.css?vue&type=style&index=0&id=3dab456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab456a",
  null
  
)

export default component.exports